const initialState = {
  orders: [],
  shoeData: [],
};

export default function (state = initialState, action) {
  return state;
}
